<template>
  <div class="onePage">
    <div class="headline">选择项目分类</div>
    <div class="small_headline">选择一级品类</div>
    <el-select v-model="onePageData.calssName" placeholder="请选择">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <div class="scheme_class">
      <span>方案类型：</span>
      <el-radio v-model="onePageData.packageType" label="1">套餐</el-radio>
      <el-radio v-model="onePageData.packageType" label="2">代金券</el-radio>
    </div>
    <div class="newClass">
      当前选定的品类：
      <span style="color:#008AFF">{{ onePageData.calssName }}</span>
    </div>
    <div class="scheme_class">
      <span>是否加入商品库：</span>
      <el-radio v-model="onePageData.joinBank" label="1">是</el-radio>
      <el-radio v-model="onePageData.joinBank" label="2">否</el-radio>
    </div>
  </div>
</template>

<script>
export default {
  props: ["itemClass", "oneState"],
  data() {
    return {
      onePageData: {
        calssName: "", // 一级分类名
        packageType: "1", //方案类型
        joinBank: "1" //是否加入商品库
      },
      joinBank: "1",
      scheme_class: "1",
      options: [
        {
          value: "快餐",
          label: "快餐"
        },
        {
          value: "蛋糕",
          label: "蛋糕"
        },
        {
          value: "早餐",
          label: "早餐"
        },
        {
          value: "面食",
          label: "面食"
        }
      ],
      value: ""
    };
  },
  mounted() {
    this.onePageData.calssName = this.itemClass;
  },
  watch: {
    onePageData: {
      handler(val) {
        console.log(val)
        this.$emit("updata:itemClass", val.calssName);
      },
      deep: true
    },
    "onePageData.packageType"(val) {
      console.log(val);
      this.$emit("addType", val);
    },
    // itemClass(val) {
    //   this.$emit("updata:itemClass", val)
    // },
    oneState(val) {
      // 将数据提交到父组件
      console.log(val)
      if (val == true) {
        this.$emit("upOneData", this.onePageData);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.onePage {
  .headline {
    margin: 30px 0px;
    font-size: 16px;
    font-weight: 500;
  }
  .small_headline {
    font-size: 14px;
    margin-bottom: 15px;
  }
  .scheme_class,
  .newClass {
    margin-top: 30px;
  }
}
</style>
